import React, { useEffect } from 'react';
import SiteNav, { GAMES_NAV_LINKS } from '../components/SiteNav';
import LibbyGameMount from '../components/LibbyGameMount';
import useNavSolid from '../hooks/useNavSolid';
import { getGameById, getGameStartMode } from '../data/games';
import { PUBLIC_SITE_ORIGIN } from '../config';
import ParentNewsletterCta from '../components/ParentNewsletterCta';

export default function GamePlayPage({ gameId }) {
  const navSolid = useNavSolid(8);
  const game = getGameById(gameId);

  useEffect(() => {
    if (!game) {
      document.title = 'Game not found — Libby the Lion & Friends';
      return;
    }
    document.title = `${game.title} — Libby the Lion & Friends`;
    const canonical = `${PUBLIC_SITE_ORIGIN}/play/${game.id}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonical);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', canonical);
  }, [game]);

  if (!game) {
    return (
      <div className="v2-shell games-shell">
        <SiteNav solid={navSolid} links={GAMES_NAV_LINKS} brandHref="/" />
        <main className="games-main games-main--play">
          <p className="games-muted" role="status">
            We couldn&apos;t find that game.{' '}
            <a href="/games">Browse all games</a>.
          </p>
        </main>
      </div>
    );
  }

  return (
    <div
      className={[
        'v2-shell games-shell games-shell--play',
        game.id === 'detective-tully' && 'games-shell--detective-tully',
        game.id === 'color-with-me' && 'games-shell--color-with-me',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <SiteNav solid={navSolid} links={GAMES_NAV_LINKS} brandHref="/" />
      <main className="games-main games-main--play">
        <LibbyGameMount
          key={game.id}
          startMode={getGameStartMode(game.id)}
          className="libby-game-mount--play"
        />
        <ParentNewsletterCta variant="play" />
      </main>
    </div>
  );
}
